import { ProductionKey } from './ProductionKey';

export enum ProcessingKey {
  MESOCARPO = 'mesocarpo_processing',
  FLOCOS = ProductionKey.FLOCOS,
}

export function getProcessingKeyLabel(processingKey: ProcessingKey): string {
  switch (processingKey) {
    case ProcessingKey.MESOCARPO:
      return 'Beneficiamento';
    case ProcessingKey.FLOCOS:
      return 'Produção e revisão de flocos';
  }
}
